
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import {
  NbaItem,
  NBAComponent,
  NextBestActivitiesComputed,
  NextBestActivitiesData,
  NextBestActivitiesMethods,
  NextBestActivitiesProps,
} from './NextBestActivities';
import { getLayoutClass } from './NextBestActivitiesUtils';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src';
import OwcNbaItem from './NextBestActivitiesItem.vue';
import OwcDataComponent from '@owc-utils/Mixins/OwcDataComponent';
import Personalisation from '@owc-utils/Mixins/Personalisation';

/**
 * Next Best Activities Component for OneWeb
 * The NBAs are quick links for next actions the user can take after seeing a page.
 * They are usually used in the bottom of the page to navigate the user to other applications
 * (configurator, dealer locator, etc.) or other secondary content.
 *
 * @vue-prop {string} datajson - Config and Component's data coming from CMS
 * @vue-prop {boolean} [darkMode=false] - toggles dark mode. Currently experimental and since we're not sure if this is a CMS config or a template config, we're keeping it as a prop.
 */
export default (ComponentInitializeDispatcher as NBAComponent).extend<
  NextBestActivitiesData,
  NextBestActivitiesMethods,
  NextBestActivitiesComputed,
  NextBestActivitiesProps
>({
  name: 'owc-nba',
  components: {
    OwcNbaItem,
    ValidationBoxWrapper,
  },
  mixins: [OwcDataComponent, Personalisation],
  computed: {
    itemsCount: function() {
      return this.personaliseableData?.nbaItems?.length;
    },
    items: function() {
      if (this.isIconModeOn) {
        return this.personaliseableData?.nbaItems;
      }

      return this.personaliseableData?.nbaItems?.map((item: NbaItem) => ({ ...item, icon: '' }));
    },
    layoutClass: function() {
      return getLayoutClass(this.itemsCount);
    },
    isDarkMode: function() {
      return Boolean(this.personaliseableData?.darkMode);
    },
    isIconModeOn: function() {
      return this.personaliseableData?.hasIcons;
    },
  },
});
